import { render } from "./DisclosureAuditDashboard.vue?vue&type=template&id=545fc19a&scoped=true"
import script from "./DisclosureAuditDashboard.vue?vue&type=script&lang=js"
export * from "./DisclosureAuditDashboard.vue?vue&type=script&lang=js"

import "./DisclosureAuditDashboard.vue?vue&type=style&index=0&id=545fc19a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545fc19a"]])

export default __exports__